import { h } from 'preact'
import { useOrganization, usePublicProfile, usePublicProfiles } from 'lib/membershipAppStateHooks'
import { useChatChannel } from 'lib/chatHooks'
import { ChatListMember } from './ChatListMember'
import './index.sass'
import EndUserDMAvatar from 'components/EndUserDMAvatar'
import EndUserAvatar from 'components/EndUserAvatar'
import { useMyPublicProfileDid } from 'resources/auth'


export function DMChatListMember({
  isSelected, forwarding, onToggleSelection, memberUserDids,
  myPublicProfile, organizationApikey, senderUserDid, ...props
}) {
  const otherUserDids = (memberUserDids || []).filter(did => did !== myPublicProfile.did)
  const { publicProfiles } = usePublicProfiles(otherUserDids, 'OrganizationChatPage')

  const {
    chatChannel,
  } = useChatChannel(props.uid, 'OrganizationChatPage')

  const myPublicProfileDid = useMyPublicProfileDid()
  const { publicProfile: senderProfile } = usePublicProfile(senderUserDid, 'OrganizationChatPage')

  const {
    organization
  } = useOrganization(organizationApikey, 'OrganizationChatPage')

  const orgName = organization?.name || organizationApikey

  const senderIsNotMe = senderProfile?.did !== myPublicProfileDid
  const senderName = senderIsNotMe ? (senderProfile?.displayName || senderProfile?.username)?.substring(0, 10) : 'You'

  // Helper function to get display name from a profile
  const publicProfileToDisplayName = (profile) => {
    return profile?.displayName || profile?.username || 'Unknown User'
  }

  // Determine if this is a direct chat (1-on-1)
  const isDirectChat = chatChannel.memberUserDids?.length === 2 && !chatChannel.isGroupChat

  // Generate chat name based on members
  const generateChatName = () => {
    if (isDirectChat) {
      // For direct chats, find the other member's profile
      const otherMemberProfile = publicProfiles.find(profile => myPublicProfile.did !== profile.did)

      if (!otherMemberProfile) return chatChannel.name

      const userChatName = publicProfileToDisplayName(otherMemberProfile)
      const isChannelNameDefault = chatChannel.name === 'unnamed chat' || chatChannel.name === "DefaultChatName"
      return isChannelNameDefault ? userChatName : chatChannel.name
    } else {
      // For group chats
      if (chatChannel.name && chatChannel.name !== 'DefaultChatName') {
        return chatChannel.name
      }

      // Create a Set of other member DIDs
      const otherMemberDids = new Set(chatChannel.memberUserDids)
      otherMemberDids.delete(myPublicProfile.did)

      // Filter the profiles to get only the other members
      const otherMembers = publicProfiles
        .filter(profile => otherMemberDids.has(profile.did))
      const firstThreeNames = otherMembers
        .slice(0, 3)
        .map(profile => publicProfileToDisplayName(profile))

      const additionalCount = otherMembers.length - 3

      if (additionalCount <= 0) {
        return firstThreeNames.join(', ')
      } else {
        return `${firstThreeNames.join(', ')} + ${additionalCount} others`
      }
    }
  }

  const chatName = generateChatName()

  // Original conditions for determining if we should use the user's name
  // const isChannelNameIsDM = (
  //   chatChannel.name === 'unnamed chat' ||
  //   !chatChannel.organizationApikey &&
  //   chatChannel.memberUserDids?.length === 2 &&
  //   !chatChannel.isGroupChat
  // )


  const otherMemberProfile = publicProfiles.find(profile => myPublicProfile.did !== profile.did)


  const chatImage = chatChannel.imageUrl
  return <ChatListMember {...{
    ...props,
    organization,
    myPublicProfile,
    isSelected,
    forwarding,
    onToggleSelection,
    name: chatName,
    orgName,
    orgAvatar: organization?.consumer_icon,
    avatar: isDirectChat ? <EndUserAvatar {...{
      publicProfile: otherMemberProfile,
      size: 'md'
    }} /> : <EndUserDMAvatar {...{
      publicProfiles,
      chatImage,
      size: 'md'
    }} />,
    uid: chatChannel.uid,
    senderName,
    publicProfiles,
  }} />
}
